import TextLockupV2 from "components/elements/textLockupV2"
import PropTypes from "prop-types"
import React, { useState } from "react"
import { Accordion } from "react-bootstrap"
import AccordionItem from "./accordion-item"
import "./section-grid-accordion-v2.scss"

const SectionGridAccordionV2 = ({ accordions, text, title }) => {
  const [activeIndex, setActiveIndex] = useState("")
  return (
    <section className="section-grid-accordion-v2">
      <div className="container-v2">
        <div className="section-grid-accordion-v2--content">
          {title && (
            <h2 className="section-grid-accordion-v2--title">
              <TextLockupV2>{title}</TextLockupV2>
            </h2>
          )}

          {text?.childrenMarkdownRemark?.[0]?.html && (
            <div
              className="section-grid-accordion-v2--text"
              dangerouslySetInnerHTML={{
                __html: text?.childrenMarkdownRemark?.[0]?.html,
              }}
            />
          )}
        </div>
        {accordions && accordions?.length > 0 && (
          <div className="section-grid-accordion-v2--content-accordion-grid">
            <Accordion activeKey={activeIndex} onSelect={setActiveIndex}>
              {accordions?.map(accordion => (
                <AccordionItem
                  activeIndex={activeIndex}
                  content={accordion.content}
                  heading={accordion.title}
                  icon={accordion.icon}
                  index={accordion.id}
                  isAccordion={true}
                  key={accordion.id}
                />
              ))}
            </Accordion>
          </div>
        )}
      </div>
    </section>
  )
}

export default SectionGridAccordionV2
SectionGridAccordionV2.propTypes = {
  accordions: PropTypes.arrayOf(PropTypes.object).isRequired,
  text: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
}
